import { ApiIntegrationService } from '../api/api-types/service.api';

export const integrationServiceMocks: ApiIntegrationService[] = [
	{
		id: 1,
		name: 'Integration Service 1',
		shortName: 'IntServ1',
		soundex: 'I123',
	},
	{
		id: 2,
		name: 'Integration Service 2',
		shortName: 'IntServ2',
		soundex: 'I123',
	},
];
